import { render, staticRenderFns } from "./orderSalsePrice.vue?vue&type=template&id=d7100970&scoped=true&"
import script from "./orderSalsePrice.vue?vue&type=script&lang=js&"
export * from "./orderSalsePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7100970",
  null
  
)

export default component.exports